module.exports = __webpack_public_path__ + "static/media/nl.dc5ebd98.svg";